var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.token && _vm.$route.path !== '/pilih-outlet')?_c('navbar'):_vm._e(),(!_vm.token && _vm.$route.path !== '/login')?_c('navbarPublic'):_vm._e(),_c('v-main',{staticStyle:{"background":"#FFFFFF"},attrs:{"light":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }